"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var services_1 = require("../../services");
var Tools = /** @class */ (function () {
    function Tools() {
    }
    Tools.IsDevelopment = function () {
        return ((process.env.NODE_ENV) && (process.env.NODE_ENV === 'development'));
    };
    Tools.SetQuantitySizeGuideActive = function (value) {
        if (this.IsDevelopment())
            console.log('SetQuantitySizeGuideActive', value);
        services_1.StorageServices.SetCookieUserSizeGuideActive(value);
    };
    Tools.CanCreateSizeGuide = function () {
        var can = false;
        try {
            var user = services_1.StorageServices.GetCookieUser();
            can = ((!(user)) || ((user.SizeGuidesAvailable || 0) === 0) || (((user.SizeGuidesAvailable || 0) - (user.SizeGuideActive || 0)) > 0));
        }
        catch (e) {
            console.log("ERROR CanCreateSizeGuide", e);
        }
        return can;
    };
    Tools.AddSizeGuideActive = function () {
        services_1.StorageServices.SetCookieUserSizeGuideActiveChange(1);
    };
    Tools.SubstractSizeGuideActive = function () {
        services_1.StorageServices.SetCookieUserSizeGuideActiveChange(-1);
    };
    Tools.UserMustCreateRelatedCode = function () {
        var must = false;
        try {
            var user = services_1.StorageServices.GetCookieUser();
            must = ((user) && ((user.PlatformId === 2) || (user.PlatformId === 200)));
        }
        catch (e) {
            console.log("ERROR UserMustCreateRelatedCode", e);
        }
        return must;
    };
    return Tools;
}());
exports.default = Tools;
//# sourceMappingURL=Tools.js.map